/*
 * 캐릭터 화법 정의서
 * 황둥이: ~네/~지/~잖아, 여유 있고 부드러운 호흡, "어서 와"·"마침", 머그컵을 건넨다.
 * 삐용이: ~야!/~지!, 빠른 단문과 느낌표, "속보!"·"대박", 마이크를 들이댄다.
 * 라이언: ~군/~하네/~하지, 격식 있는 정형 템포, "흠"·"기준", 안경을 올리며 클립보드를 친다.
 * 콩이: ~야/~을까?/~거든, 꼭꼭 씹는 느린 템포, "저기…"·"으응", 양볼을 오물거리거나 저금통을 안는다.
 * 록이: 존댓말 ~군요/~어요, 차분한 중문, "천천히", 깃털 펜을 쥔다.
 * 미오: ~다/~군/~뿐, 수식 없는 정밀한 템포, "흠"·"…", 회중시계를 보거나 단안경을 조율한다.
 * 까미: ~냐?/~지/~잖아, 과시하듯 튀는 리듬, "야"·"인정", 금목걸이나 폰을 만진다.
 * 부기: ~군/~야, 툭 던지는 단문, "어, 왔어?"·"글쎄"·"냅둬", 차 한 모금 또는 나침반을 톡 친다.
 * 토비: ~잖아?!/~자고!, 빠르고 통통 튀는 비트, "완전"·"고!", 조이스틱을 만진다.
 * 웅이: ~단다/~렴/~아, 달래는 포근한 호흡, "안심해", 조각보 담요를 덮어준다.
 * 모카: ~야!/~네!, 살갑고 리드미컬, "어서 와~", 앞치마를 정돈한다.
 * 바닐라: ~잖아!/~지?, 명랑하고 가벼운 리듬, "손님!", 문을 활짝 연다.
 * 너굴: ~지!/~잖아, 시원시원한 빠른 템포, "잘 왔어", 주먹을 불끈 쥔다.
 * 여우니: ~걸/~네, 고저와 포즈로 궁금증을 만든다, "…흥미롭네"·"사실은", 태블릿을 슥 넘긴다.
 * 루미: ~야/~줄게/~자, 온기 있는 흐름, "괜찮아", 구급함을 들고 눈을 맞춘다.
 * 전원 같은 종결을 쓰지 않으며 페럿 행동 지문은 앞치마만 허용한다.
 */

export type MbtiGreetings = Record<string, Record<string, string>>;

export const MBTI_GREETINGS: MbtiGreetings = {
  hwangdoongi: {
    ENFJ: '어서 와, 마침 따뜻한 거 내리던 참이었어! 너도 공동체 자산가형이구나 — 함께 갈 때 더 멀리 가는 타입, 나랑 똑같네. 편하게 머물다 가!',
    ESFJ: '어서 와! 가족 자산가형이라니, 소중한 사람들 먼저 챙기는 그 마음 나랑 똑같잖아. 우리 카페에선 늘 환영이야!',
  },
  bbiyong: {
    ENFP: '삐용삐용— 속보! 나랑 같은 테마 탐험가형 등장! 새로운 거 보면 심장부터 뛰는 타입 맞지? 반가워, 우리 통했다!',
  },
  ryan: {
    ESTJ: '흠, 고정수익 관리자형이군. 원칙과 계획으로 움직이는 타입 — 나와 같아서 마음에 드는걸. 잘 부탁하네.',
    ENTJ: '전략 리더형이라, 반갑군. 큰 그림부터 그리는 타입은 흔치 않지. (클립보드를 탁) 우리, 얘기가 잘 통하겠어.',
  },
  kongi: {
    ISTJ: '저기… 너도 성실 저축가형이야? (양볼 오물오물) 차곡차곡 모으는 재미 아는 사람, 처음 만났거든. …으응, 진짜 반가워!',
    ISFJ: '너도 안전 수호자형이구나…! 소중한 건 잃지 않게 꼭 지키는 타입. 내 도토리 저금통만큼 믿음직해. 반가워!',
  },
  roki: {
    INFJ: '통찰 설계가형이시군요. 조용히, 그러나 멀리 보는 눈 — 저와 같은 걸 보고 계셨네요. 만나서 반갑습니다.',
    INFP: '신념 투자가형이시네요. 숫자보다 자신의 가치를 먼저 믿는 분 — 저도 그 길을 걷고 있어요. 반갑습니다.',
    ISFP: '감성 미니멀형이시군요. 꼭 필요한 것만 곁에 두는 단정한 마음, 저와 닮았어요. 천천히 함께 가요.',
  },
  mio: {
    INTJ: '…장기 비전가형. 나와 같은 타입이네. (회중시계를 힐끗) 남들이 오늘을 볼 때 몇 년 뒤를 보는 사람 — 드물어서, 조금 반가워.',
    INTP: '분석 탐구자형이라. 감이 아니라 근거로 움직이는 타입… 나쁘지 않아. 아니, 솔직히 꽤 반가워.',
  },
  kkami: {
    ENTP: '오~ 너도 공격적 매수 본능형?! 안목 있는데? 나 까미야. 과감한 타입끼리는 서로 알아보는 법이지. 인정!',
  },
  bugi: {
    ISTP: '어, 왔어? …냉정 실행가형. 나랑 같네. 말보다 행동, 소음엔 무반응 — 좋은 타입이야. (차 한 모금) 서두를 거 없어.',
  },
  tobi: {
    ESTP: '왔다!! 단타 행동가형!! 나랑 완전 같은 타입이잖아?! 판단 빠르고 손도 빠른 우리 — 반가워, 잘 지내보자고!',
    ESFP: '오오, 감각형 소비러형! 좋은 건 바로 알아보는 타입이지? 나랑 텐션 잘 맞겠는데? 반가워!!',
  },
  woongi: {
    ISFJ: '어서 오렴. …너도 안전 수호자형이구나. 소중한 건 담요로 감싸듯 꼭 지키는 타입 — 나랑 같단다. 여기 옆자리, 따뜻해. 안심해.',
  },
  mocha: {
    ESFJ: '어서 와~! 너도 가족 자산가형이구나! 소중한 사람들 챙길 때 제일 행복한 타입, 나랑 바닐라랑 똑같아. 우리 셋이 같은 편이네!',
  },
  vanilla: {
    ESFJ: '어서 와! 나 바닐라야. 모카랑 나랑 같은 타입인데 너도라니 — 오늘 제일 반가운 손님이잖아! 편하게 있다 가!',
  },
  neogul: {
    ESTP: '오, 단타 행동가형! 빠르게 보고 빠르게 움직이는 타입, 너도 그렇지? 그 판단력 하나는 서로 인정하자고. 잘 왔어!',
  },
  yeouni: {
    ENTP: '…공격적 매수 본능형. 흥미롭네, 나랑 같은 타입이라니. (태블릿을 슥) 과감하게 움직이는 사람, 지켜볼 맛이 있거든. 반가워.',
  },
  lumi: {
    ENFJ: '와, 너도 공동체 자산가형이구나! 누군가를 챙길 때 제일 힘이 나는 타입 — 나랑 똑같아! 곤란할 땐 내가 제일 먼저 달려갈게. 반가워!',
  },
};

export function getGreeting(castId: unknown, code: unknown): string {
  if (typeof castId !== 'string' || typeof code !== 'string') return '';
  return MBTI_GREETINGS[castId]?.[code.trim().toUpperCase().slice(0, 4)] || '';
}

export function getGreetingOpening(greeting: string): string {
  if (!greeting) return '';
  const match = greeting.match(/^.*?[.!?](?:!|\?)?/);
  return match?.[0] || greeting;
}
